/**
 * Table Row Component.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import childrenPropType from 'js/PropTypes/children';

/**
 * Table Row Class
 */
class Row extends Component {
    static propTypes = {
        children: childrenPropType,
        className: PropTypes.string,
    };

    static defaultProps = {
        children: null,
        className: null,
    };

    /**
     * Render the table row.
     *
     * @returns {React.node}
     */
    render() {
        const { children, className } = this.props;

        return (
            <tr className={className}>
                {children}
            </tr>
        );
    }
}

export default Row;
